<template>
    <div class="hidden" id="sentry">Sentry is enabled {{defineSentry}}</div>
</template>

<script>
    import * as Sentry from "@sentry/vue";
    import {getCurrentInstance} from "vue";

    export default {
        name: "sentry",
        props: {
            release: String,
            url: String,
            user: {
                Type: Object,
                default: null,
            },
        },
        computed:{
            defineSentry(){
                console.log('Sentry set to',this.url)

                // Get the App instance made in app.js to provide to Sentry Init per
                //   https://docs.sentry.io/platforms/javascript/guides/vue/#vue-specific-configuration
                const instance = getCurrentInstance()
                const app = instance.appContext.app

                Sentry.init({
                    app: app,
                    dsn: this.url,
                    release: this.release,
                    integrations: [Sentry.vueIntegration({attachProps: true, logErrors: true})],
                    beforeSend: function (event) {
                        // Check for IE10 or lower; if it is lower then don't send to Sentry.
                        if (navigator.userAgent.indexOf("MSIE") >= 0) {
                            return null;
                        }
                        return event;
                    }
                });
                if(this.userId !== null || this.userEmail !== null){
                    Sentry.setUser({
                        'id': this.userId,
                        'email': this.userEmail,
                    });
                }
                return this.url;
            },
            userId(){
                if(this.user !== null){
                    return this.user.id;
                }
                return null;
            },
            userEmail(){
                if(this.user !== null){
                    return this.user.email;
                }
                return null;
            }
        }
    }

</script>
